import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

@Injectable({
    providedIn: 'root'
  })
export class ExcelExportService {
    
    
    constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

    exportExcel(reportTitle: string, columnNames: string[], lst: {[key: string]: string}[], columnWidths: string, 
        generatedBy: string, generatedOn: string) {
        const header = columnNames;//Object.keys(lst[0]);
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet(reportTitle);
        worksheet.views = [
            {state: 'frozen', ySplit: 3}
        ];
        let titleRow = worksheet.addRow([reportTitle]);
        titleRow.font = {
            name: 'Calibri',
            size: 20,
            bold: true,
        }

        worksheet.mergeCells('A1:E1'); 

        let createdByOnRow = worksheet.addRow(['Generated By', generatedBy, 'Generated On', generatedOn]);
        createdByOnRow.eachCell((cell, number) => {
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 12, 
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        });
        let headerRow = worksheet.addRow(header);
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '808080' },
            }
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 14,
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        });
        const list = []

        lst.forEach((row: any) => {
            let ls = [];
            for(let t = 0; t < columnNames.length; t++) {
                ls.push(row[columnNames[t]]);
            }

            list.push(ls);
        })

        list.forEach(d => {
            let row = worksheet.addRow(d);
            row.eachCell((cell, number) => {
                cell.font = {
                    name: 'Calibri',
                    family: 2,
                    bold: false,
                    size: 12,
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });
        });

        for (var i = 0; i < columnWidths.split(',').length; i++) {
            // const dobCol = worksheet.getColumn(i);
            // dobCol.eachCell({ includeEmpty: false }, function (cell, rowNumber) {
            //     cell.border = {
            //     top: { style: 'thin' },
            //     left: { style: 'thin' },
            //     bottom: { style: 'thin' },
            //     right: { style: 'thin' }
            //     }
            // });
            // if (i == 3) {
            //     worksheet.getColumn(i).width = 30;
            //     worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // } else if (i == 11 || i == 12) {
            //     worksheet.getColumn(i).width = 50;
            //     worksheet.getColumn(i).alignment = { vertical: 'justify', horizontal: 'left', wrapText: true }
            // } else if (i == 5) {
            //     worksheet.getColumn(i).width = 40;
            //     worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // } else if (i == 9 ||i==10) {
            //     worksheet.getColumn(i).width = 30;
            //     worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // }
            // else {
                worksheet.getColumn(i+1).width = +columnWidths.split(',')[i];
                worksheet.getColumn(i+1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            // }
        }
        titleRow.border = {
            top: { style: 'thin', color: { argb: 'FFFFFF' } },
            left: { style: 'thin', color: { argb: 'FFFFFF' } },
            bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
            right: { style: 'thin', color: { argb: 'FFFFFF' } }
        };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        headerRow.height = 35;
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, reportTitle + '.xlsx');
        });        
    }

    //For Dynamic Data
    exportExcelForDynamic(reportTitle: string, columnNames: string[], lst: {[key: string]: string}[], columnWidths: string, 
        generatedBy: string, generatedOn: string,selectedBoardDetail:string,selectedLotteryEventDetails: string) {
        const header = columnNames;//Object.keys(lst[0]);
        let workbook = new Workbook();
        let worksheet = workbook.addWorksheet(reportTitle);
        worksheet.views = [
            {state: 'frozen', ySplit: 3}
        ];

        let titleRow = worksheet.addRow([reportTitle]);
        titleRow.font = {
            name: 'Calibri',
            size: 20,
            bold: true,
        }

        worksheet.mergeCells('A1:E1'); 

        let createdByOnRow = worksheet.addRow(['Generated By', generatedBy, 'Generated On', generatedOn]);
        createdByOnRow.eachCell((cell, number) => {
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 12, 
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        });

        //add black row
        let blackLineRow1 = worksheet.addRow([]);
        let blackLineRow2 = worksheet.addRow([]);
        blackLineRow2.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '808080' },
            };
        });
        for (let i = 1; i <= columnNames.length; i++) {
            blackLineRow2.getCell(i).fill = {
                type: 'pattern',
                pattern: 'solid',
                // Gray color
                fgColor: { argb: '808080' },
            };
        }
        if (selectedBoardDetail !== null) {
            let staticData1 = worksheet.addRow(['Board']);
            staticData1.eachCell((cell, number) => {
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 14,
            };
            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } }, // Black color
                bottom: { style: 'thin', color: { argb: '000000' } }, // Black color
                left: { style: 'thin', color: { argb: '000000' } }, // Black color
                right: { style: 'thin', color: { argb: '000000' } } // Black color
            };
            });
        }
        worksheet.mergeCells('A5:B5');

        let staticData3 = worksheet.getRow(5).getCell(3);
            staticData3.value = selectedBoardDetail;
            staticData3.font = {
                name: 'Calibri',
                bold: true,
            };
            staticData3.border = {
                top: { style: 'thin', color: { argb: '000000' } },
                bottom: { style: 'thin', color: { argb: '000000' } },
                left: { style: 'thin', color: { argb: '000000' } },
                right: { style: 'thin', color: { argb: '000000' } }
            };

        
        worksheet.mergeCells('C5:D5');
        if (selectedLotteryEventDetails !== null) {
        let staticData2 = worksheet.addRow(['LotteryEvents']);
        staticData2.eachCell((cell, number) => {
        cell.font = {
            name: 'Calibri',
            family: 2,
            bold: true,
            size: 14,
        };
        cell.border = {
            top: { style: 'thin', color: { argb: '000000' } }, // Black color
            bottom: { style: 'thin', color: { argb: '000000' } }, // Black color
            left: { style: 'thin', color: { argb: '000000' } }, // Black color
            right: { style: 'thin', color: { argb: '000000' } } // Black color
        };
        });
        staticData3.alignment = {
            wrapText: true
        };
    
    worksheet.mergeCells('A6:B6'); 

    let staticData4 = worksheet.getRow(6).getCell(3);
    staticData4.value = selectedLotteryEventDetails;
    staticData4.font = {
        name: 'Calibri',
        bold: true,
    };
    staticData4.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } }
    };
    staticData4.alignment = {
        wrapText: true 
    };
    worksheet.getRow(5).height = 50;
}
    worksheet.mergeCells('C6:D6'); 

    //add black row
    let blackLineRow3 = worksheet.addRow([]);

        let headerRow = worksheet.addRow(header);
        headerRow.eachCell((cell, number) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '808080' },
            }
            cell.font = {
                name: 'Calibri',
                family: 2,
                bold: true,
                size: 14,
            };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        });
        const list = []

        lst.forEach((row: any) => {
            let ls = [];
            for(let t = 0; t < columnNames.length; t++) {
                ls.push(row[columnNames[t]]);
            }

            list.push(ls);
        })

        list.forEach(d => {
            let row = worksheet.addRow(d);
            row.eachCell((cell, number) => {
                cell.font = {
                    name: 'Calibri',
                    family: 2,
                    bold: false,
                    size: 12,
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });
        });

        for (var i = 0; i < columnWidths.split(',').length; i++) {
                worksheet.getColumn(i+1).width = +columnWidths.split(',')[i];
                worksheet.getColumn(i+1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        }
        titleRow.border = {
            top: { style: 'thin', color: { argb: 'FFFFFF' } },
            left: { style: 'thin', color: { argb: 'FFFFFF' } },
            bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
            right: { style: 'thin', color: { argb: 'FFFFFF' } }
        };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        headerRow.height = 35;
        workbook.xlsx.writeBuffer().then((data) => {
            let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            fs.saveAs(blob, reportTitle + '.xlsx');
        });        
    }
}